import React, { useEffect, useState } from 'react';
import { Download, Loader2, FileQuestion } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import { Button } from '@/components/ui/button';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle,
} from '@/components/ui/dialog';

export const canPreview = (mime, name = '') => {
    const m = mime || '';
    return m.startsWith('image/') || m === 'application/pdf' || /\.pdf$/i.test(name);
};

export function DocPreviewDialog({ doc, onClose, onDownload }) {
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!doc) { setUrl(null); return; }
        let alive = true;
        setLoading(true);
        supabase.storage.from('documents').createSignedUrl(doc.storage_path, 600).then(({ data }) => {
            if (alive) { setUrl(data?.signedUrl || null); setLoading(false); }
        });
        return () => { alive = false; };
    }, [doc]);

    if (!doc) return null;
    const isImage = (doc.mime_type || '').startsWith('image/');
    const isPdf = (doc.mime_type || '') === 'application/pdf' || /\.pdf$/i.test(doc.name || '');

    return (
        <Dialog open onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-4xl" data-testid="doc-preview-dialog">
                <DialogHeader>
                    <DialogTitle className="font-heading text-xl flex items-center justify-between gap-4 pr-6">
                        <span className="truncate">{doc.name}</span>
                        <Button size="sm" variant="outline" onClick={() => onDownload(doc.storage_path)} data-testid="doc-preview-download">
                            <Download size={14} className="mr-1.5" /> Télécharger
                        </Button>
                    </DialogTitle>
                </DialogHeader>
                <div className="min-h-[300px] max-h-[70vh] flex items-center justify-center bg-surface-muted/50 rounded-lg overflow-hidden">
                    {loading && <Loader2 className="animate-spin text-muted-foreground" size={22} />}
                    {!loading && url && isImage && (
                        <img src={url} alt={doc.name} className="max-w-full max-h-[70vh] object-contain" data-testid="doc-preview-image" />
                    )}
                    {!loading && url && isPdf && (
                        <iframe src={url} title={doc.name} className="w-full h-[70vh]" data-testid="doc-preview-pdf" />
                    )}
                    {!loading && (!url || (!isImage && !isPdf)) && (
                        <div className="flex flex-col items-center gap-3 text-muted-foreground py-10" data-testid="doc-preview-unavailable">
                            <FileQuestion size={36} strokeWidth={1.3} />
                            <p className="text-sm">Aperçu indisponible pour ce type de fichier.</p>
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}
